<template>
  <div id="zfbIntroductionPage">
    <div class="introductionBg"></div>
    <footer>
      <div class="footerUnit">
        <a class="kefu" href="https://work.weixin.qq.com/kfid/kfce82ed2eaaae38c7f">
          <div class="kefu">
            <div class="kefuImg"></div>
            <div class="kefuText">客服</div>
          </div>
        </a>
        <div class="submit" @click="getInterest">立即参保</div>
      </div>
    </footer>

    <!-- 手机验证弹窗 -->
    <el-dialog
      :visible.sync="claimDialog"
      width="86%"
      :modal="true"
      :modal-append-to-body="false"
      :show-close="false"
      class="claimDialog"
      center>
      <div class="head">
        <div class="title">温馨提示</div>
        <div class="title-hint">请先校验手机号码再领取权益哦~</div>
      </div>
      <div class="check">
        <el-input type="number" v-model="account" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入手机号码" class="account"></el-input>
        <el-button @click="receiveCheck" class="receive">立即领取</el-button>
        <div class="cueWords">
          <div class="prompt">
            <span :class="promptStates"></span>
            <span class="errorPrompt" v-html="errorPrompt">{{errorPrompt}}</span>
          </div>
          <div class="contact">如有疑问请致电：<a href="tel:02082513114" >020-82513114</a></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "zfbIntroductionPage",
    data() {
      return {
        saleToken: '',
        rightsToken: '',
        eventLogToken: '',
        /* 手机验证弹窗 */
        claimDialog: false,
        account: '',
        promptStates: 'none',
        errorPrompt: '',
        startTime: '',
        router: null,
        loginAccount: '',
      }
    },
    methods: {
      //-- 立即领取权益
      getInterest(){
        let that = this;

        if (that.$$.isValidObj(that.rightsToken) && this.$$.isValidObj(this.router)){
          window.location.href = that.router + '&eventLogToken='+that.eventLogToken;
        }else {
          that.claimDialog = true;
        }
      },

      //-- 手机号校验
      receiveCheck(){
        let that = this;
        const errorMsg = that.validationForm_phone(that.account);
        console.log(errorMsg);
        if(errorMsg != null) return that.errorPrompt = errorMsg;

        //-- 图形验证
        if (!that.$$.isValidObj(that.startTime)) {
          that.$$.geeTestInit(that);
        }
      },

      //-- 验证手机号
      validationForm_phone(account){
        if(!this.$$.isValidObj(account)) return "请输入手机号~";
        if(!this.$$.constant.phoneReg.test(account)) return "手机号格式错误，请重新输入！";

        return null;
      },

      //-- 权益登录手机校验
      phoneCheck(){
        let that = this;
        let loading = that.Loading.service({fullscreen: true});

        //-- 获取权益数据
        if (!that.$$.isValidObj(that.saleToken)) {
          that.$$.alert({
            message: '链接参数有误，请重新领取权益!',
            type: 'warning',
            onOk: function () {
              that.$router.go(-1);
            }
          });
        }else {
          that.axios.post('/member/unicom/check', {phoneNum: that.account, saleToken: that.saleToken, startTime: that.startTime}).then((response) => {
            that.$nextTick(() => loading.close());
            let data = response.data;
            $('.contact').hide();
            that.promptStates = 'none';
            this.rightsToken = '';

            if (data.success) {
              let {rightsToken, router, eventLogToken} = data.datas;
              that.rightsToken = rightsToken;
              that.eventLogToken = eventLogToken;

              that.router = router;
              that.claimDialog = false;
              that.$message.success('验证通过！');

              //-- 本地缓存 rightsToken
              that.$$.localStorageSet('interests_rightsToken'+that.saleToken, rightsToken, 5 * 60 * 1000);
              that.$$.localStorageSet('interests_loginAccount'+that.saleToken, that.account, 5 * 60 * 1000);
              that.$$.localStorageSet('interests_router'+that.saleToken, router, 5 * 60 * 1000);
              that.$$.localStorageSet('interests_eventLogToken'+that.saleToken, eventLogToken, 5 * 60 * 1000);
              that.loginAccount = this.account;

              setTimeout(function () {
                if (that.$$.isValidObj(that.rightsToken) && that.$$.isValidObj(that.router)){
                  window.location.href = that.router + '&eventLogToken='+that.eventLogToken;
                }
              }, 1000);
            }else {
              that.startTime = '';

              const {msg, code, rightsToken} = data;

              if (that.$$.isValidObj(code)){
                that.securityNumber = code;
                that.rightsToken = rightsToken;

                $('.contact').show();
              }else if (msg.includes('您的权益领取申请正在审核中,请耐心等待!')){
                $('.contact').show();
              }

              that.errorPrompt = msg;
            }
          });
        }
      },

    },
    mounted() {
      let that = this;
      that.saleToken = decodeURIComponent(encodeURIComponent(that.$route.query.saleToken).replace(new RegExp("%20","gm"),"%2B"));

      //-- 获取权益数据
      if (!that.$$.isValidObj(that.saleToken)) {
        that.$$.alert({
          message: '链接参数有误，请重新领取权益!',
          type: 'warning',
          onOk: function () {
            that.$router.go(-1);
          }
        });
      }

      // 登录状态 - 本地缓存获取
      const rightsToken = that.$$.localStorageGet('interests_rightsToken'+that.saleToken);
      const loginAccount = that.$$.localStorageGet('interests_loginAccount'+that.saleToken);
      const router = that.$$.localStorageGet('interests_router'+that.saleToken);
      const eventLogToken = that.$$.localStorageGet('interests_eventLogToken'+that.saleToken);

      if (that.$$.isValidObj(rightsToken) && that.$$.isValidObj(loginAccount) && that.$$.isValidObj(router)) {
        that.rightsToken = rightsToken;
        that.loginAccount = loginAccount;
        that.router = router;
        that.claimDialog = false;
        that.$$.localStorageSet('interests_rightsToken'+that.saleToken, rightsToken, 5 * 60 * 1000);
        that.$$.localStorageSet('interests_loginAccount'+that.saleToken, loginAccount, 5 * 60 * 1000);
        that.$$.localStorageSet('interests_router'+that.saleToken, router, 5 * 60 * 1000);
        that.$$.localStorageSet('interests_eventLogToken'+that.saleToken, eventLogToken, 5 * 60 * 1000);
      }else {
        localStorage.removeItem('interests_rightsToken'+that.saleToken);
        localStorage.removeItem('interests_loginAccount'+that.saleToken);
        localStorage.removeItem('interests_router'+that.saleToken);
        localStorage.removeItem('interests_eventLogToken'+that.saleToken);
      }
    }
  }
</script>

<style scoped>
  #zfbIntroductionPage{
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 750px;
    overflow: scroll;
    margin: 0 auto;
    padding-bottom: 5rem;
    background: #ffffff;
  }

  #zfbIntroductionPage::-webkit-scrollbar {
    display: none;
  }

  .introductionBg{
    max-height: 667px;
    padding-top: 178%;
    background: url("../../../../static/images/product/ssk/zfbIntroduction.png") no-repeat center / cover;
  }

  /* 底部 */
  footer{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 101;
    background: #ffffff;
    width: 100%;
    border-top: 1px solid #CCCCCC;
  }
  .footerUnit{
    max-width: 750px;
    margin: 0 auto;
    text-align: center;
    height: 5rem;
    display: flex;
  }
  .kefu{
    padding: 0 1.6rem;
    height: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .kefuImg{
    width: 3rem;
    max-height: 3rem;
    padding-top: 100%;
    background: url("../../../../static/images/product/kefu-1.png") no-repeat center / cover;
  }
  .kefuText{
    text-align: center;
    font-size: 1.33rem;
    line-height: 2rem;
  }
  .submit{
    flex: 1;
    background: -webkit-linear-gradient(left,#00b07b,#017a59);
    background: linear-gradient(90deg,#00b07b,#017a59);
    color: #ffffff;
    font-size: 1.5rem;
    line-height: 5rem;
  }

  /* 验证弹窗 */
  .claimDialog /deep/ .el-dialog{
    margin-top: 30vh!important;
    border-radius: 15px;
    position: relative;
  }

  .claimDialog /deep/ .el-dialog__title{
    color: #FA6E50;
    font-size: 16px;
    font-weight: bold;
  }
  .claimDialog /deep/ .el-dialog__body{
    padding: 0px!important;
    width: 100%;
    text-align: center;
    position: absolute;
    border-radius: 15px;
    top: 0;
    left: 0;
    background: #ffffff;
  }
  .claimDialog /deep/ .el-dialog__headerbtn{
    z-index: 999;
    font-size: 2.5rem;
    top: 10px;
    right: 15px;
  }

  .claimDialog .head{
    width: 100%;
    line-height: 30px;
    border-radius: 15px 15px 0 0;
    padding: 15px 0;
    font-weight: bold;
    background: url("../../../../static/images/product/dialogBg-1.png") no-repeat center / cover;
    letter-spacing: 1px;
  }
  .head .title{
    color: #064f98;
    font-size: 16px;
  }
  .head .title-hint{
    color: #333333;
    font-size: 14px;
    text-align: center;
  }

  .check{
    padding: 20px 10%;
    background: #FFFFFF;
    border-radius: 0 0 15px 15px;
  }
  .account /deep/ .el-input__inner{
    text-align: center;
  }
  .receive{
    margin: 15px auto 10px;
  }

  .claim .getInterest>button,
  .receive{
    width: 100%;
    height: 40px;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background: #FFBA5F;
    border-radius: 4px;
    border: none;
    clear: both;
  }

  .cueWords{
    display: block;
  }
  .prompt{
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .prompt>span:first-child{
    display: inline-block;
    width: 18px;
    height: 18px;
    margin: 2px 2px 0 0;
  }

  .prompt .errorPrompt{
    max-width: calc(100% - 30px);
    color: #FA6E50;
    font-size: 14px;
    font-weight: bold;
  }
  .prompt .errorPrompt /deep/ a{
    display: inline-block;
    text-decoration: underline;
    color: #1a73e8;
  }

  .contact{
    font-size: 12px;
    color: #999999;
    margin: 20px auto 5px;
    display: none;
  }
  .contact a{
    color: #B98C65;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/zfb/introductionPage.vue